import { RedeemHowToContainer } from 'components/Redeem';
import { PageTitle } from 'components/misc';
import { Link as UiLink } from 'components/ui';
import dict from 'config/dictionary';
import externalLinks from 'config/externalLinks';
import { useAnalytics } from 'hooks';
import { Layout } from 'layouts';
import React, { useCallback, useEffect, useState } from 'react';
import { interpolate } from 'utilities/interpolate';
import styles from './how-to-redeem.module.scss';

export const ScreensHowToRedeem = () => {
  const [url, setUrl] = useState();
  const [huggg, setHuggg] = useState(null);
  const analytics = useAnalytics();
  const backAction = useCallback(() => url, [url]);
  const onContentLoaded = useCallback((_content, huggg) => {
    setHuggg((prevState) => ({ ...prevState, ...huggg }));
    setUrl(`/${huggg.shortcode}/redeem`);
  }, []);

  useEffect(() => {
    if (huggg) {
      analytics.screenViewedHugggHowTo();
    }
  }, [analytics, huggg]);

  return (
    <Layout backAction={url ? backAction : null}>
      <PageTitle title={dict.pageTitle.howToRedeem} />

      <div data-test-id="screen-how-to-redeem" className="container">
        <div className="container">
          <RedeemHowToContainer onContentLoaded={onContentLoaded} />

          {huggg && huggg.id && (
            <div className={styles.footer}>
              <h3 className={styles.footerTitle}>{dict.howTo.footerTitle}</h3>
              <p className={styles.footerCopy}>
                {interpolate(
                  dict.howTo.footerCopy,
                  '[talk_to_us_link]',
                  <UiLink.EmailHello to={externalLinks}></UiLink.EmailHello>,
                )}
              </p>
            </div>
          )}
        </div>
      </div>
    </Layout>
  );
};

export default ScreensHowToRedeem;
